import { createRouter, createWebHistory } from 'vue-router'
import HomeView from '../views/HomeView.vue'
import Archive from '../views/archive.vue'
import Archive2025 from '../views/archive/Archive2025.vue'
import TripsView from '../views/TripsView.vue'
import JanVegas from '../views/archive/JanVegas.vue'
import UkView from '../views/archive/UkView.vue'
import FebVegas from '@/views/archive/FebVegas.vue'
import IcelandView from '@/views/archive/IcelandView.vue'
import SanFrancisco from '@/views/archive/janvegas/SanFrancisco.vue'
import vegas25 from '@/views/archive/janvegas/vegas25.vue'
import vegas26 from '@/views/archive/janvegas/vegas26.vue'
import vegas27 from '@/views/archive/janvegas/vegas27.vue'
import vegas28 from '@/views/archive/janvegas/vegas28.vue'
import vegas29 from '@/views/archive/janvegas/vegas29.vue'
import vegas30 from '@/views/archive/janvegas/vegas30.vue'
import IcelandFlights from '@/views/archive/Iceland/IcelandFlights.vue'
import uk30 from '@/views/archive/uk/uk30.vue'
import uk31 from '@/views/archive/uk/uk31.vue'
import uk1 from '@/views/archive/uk/uk1.vue'
import uk2 from '@/views/archive/uk/uk2.vue'
import uk3 from '@/views/archive/uk/uk3.vue'
import uk4 from '@/views/archive/uk/uk4.vue'
import uk5 from '@/views/archive/uk/uk5.vue'
import uk6 from '@/views/archive/uk/uk6.vue'
import uk7 from '@/views/archive/uk/uk7.vue'
import uk8 from '@/views/archive/uk/uk8.vue'
import uk9 from '@/views/archive/uk/uk9.vue'
import uk10 from '@/views/archive/uk/uk10.vue'
import uk11 from '@/views/archive/uk/uk11.vue'
import uk12 from '@/views/archive/uk/uk12.vue'
import uk13 from '@/views/archive/uk/uk13.vue'
import uk14 from '@/views/archive/uk/uk14.vue'
import uk15 from '@/views/archive/uk/uk15.vue'
import AprVegas from '@/views/archive/AprVegas.vue'
import JunVegas from '@/views/archive/JunVegas.vue'
import julyvegas from '@/views/archive/julyvegas.vue'
import AugVegas from '@/views/archive/AugVegas.vue'
import Aug2Vegas from '@/views/archive/Aug2Vegas.vue'
import sepvegas from '@/views/archive/sepVegas.vue' 
import decVegas from '@/views/archive/decVegas.vue' 
import dec3Vegas from '@/views/archive/dec3Vegas.vue'
import marchvegas from '@/views/marchvegas.vue'
import f1Vegas from '@/views/archive/f1Vegas.vue'
import octVegas from "@/views/octVegas.vue"
import cesvegas from '@/views/cesvegas.vue'
import superbowlvegas from '@/views/superbowlvegas.vue'
import newzealand from '@/views/newzealand.vue'
import nodoubtvegas from '@/views/nodoubtvegas.vue'

//define store index.js
import store from '../store/index.js'


const routes = [
  {
    path: '/trips',
    name: 'home',
    component: HomeView
  },
  {
    path: '/archive/2025',
    name: 'archive2025',
    component: Archive2025
  },
  {
    path: '/archive',
    name: 'archive',
    component: Archive
  },
  {
    path: '/',
    name: '2025',
    component: TripsView
  },
  {
    path: '/janvegas',
    name: 'janvegas',
    component: JanVegas
  },
  {
    path: '/aprvegas',
    name: 'aprvegas',
    component: AprVegas
  },
  {
    path: '/junvegas',
    name: 'junvegas',
    component: JunVegas
  },
  {
    path: '/janvegas/sanfrancisco',
    name: 'sanfrancisco',
    component: SanFrancisco
  }, 
  {
    path: '/janvegas/vegas25',
    name: 'vegas25',
    component: vegas25
  }, 
  {
    path: '/janvegas/vegas26',
    name: 'vegas26',
    component: vegas26
  }, 
  {
    path: '/janvegas/vegas27',
    name: 'vegas27',
    component: vegas27
  }, 
  {
    path: '/janvegas/vegas28',
    name: 'vegas28',
    component: vegas28
  },   
  {
    path: '/janvegas/vegas29',
    name: 'vegas29',
    component: vegas29
  },   
  {
    path: '/janvegas/vegas30',
    name: 'vegas30',
    component: vegas30
  },
  {
    path: '/uk',
    name: 'uk',
    component: UkView
  },
  {
    path: '/febvegas',
    name: 'febvegas',
    component: FebVegas
  },
  {
    path: '/iceland',
    name: 'iceland',
    component: IcelandView
  },
  {
    path: '/iceland/flights',
    name: 'IcelandFlights',
    component: IcelandFlights
  },
  {
    path: '/uk/uk30',
    name: 'uk30',
    component: uk30
  },
  {
    path: '/uk/uk31',
    name: 'uk31',
    component: uk31
  },
  {
    path: '/uk/uk1',
    name: 'uk1',
    component: uk1
  },
  {
    path: '/uk/uk2',
    name: 'uk2',
    component: uk2
  },
  {
    path: '/uk/uk3',
    name: 'uk3',
    component: uk3
  },
  {
    path: '/uk/uk4',
    name: 'uk4',
    component: uk4
  },
  {
    path: '/uk/uk5',
    name: 'uk5',
    component: uk5
  },
  {
    path: '/uk/uk6',
    name: 'uk6',
    component: uk6
  },
  {
    path: '/uk/uk7',
    name: 'uk7',
    component: uk7
  },
  {
    path: '/uk/uk8',
    name: 'uk8',
    component: uk8
  },
  {
    path: '/uk/uk9',
    name: 'uk9',
    component: uk9  
  }, 
  {
    path: '/uk/uk10',
    name: 'uk10',
    component: uk10
  },
  {
    path: '/uk/uk11',
    name: 'uk11',
    component: uk11
  },
  {
    path: '/uk/uk12',
    name: 'uk12',
    component: uk12
  },
  {
    path: '/uk/uk13',
    name: 'uk13',
    component: uk13
  },
  {
    path: '/uk/uk14',
    name: 'uk14',
    component: uk14
  },
  {
    path: '/uk/uk15',
    name: 'uk15',
    component: uk15
  },
  {
    path: '/james18th',
    name: 'james18th',
    component: () => import('@/views/james18th.vue')
  },
  {
    path: '/augvegas',
    name: 'augvegas',
    component: AugVegas
  },
  {
    path: '/aug2vegas',
    name: 'aug2vegas',
    component: Aug2Vegas
  },
  {
    path: '/julyvegas',
    name: 'julyvegas',
    component: julyvegas
  },
  {
    path: '/sepVegas',
    name: 'sepvegas',
    component: sepvegas
  },
  {
    path: '/decVegas',
    name: 'decvegas',
    component: decVegas    
  },
  {
    path: '/dec3vegas',
    name: 'dec3vegas',
    component: dec3Vegas    
  },
  {
    path: '/marchvegas',
    name: 'marchvegas',
    component: marchvegas
  },
  {
    path: '/octVegas',
    name: 'octVegas',
    component: octVegas
  },
  {
    path: '/f1vegas',
    name: 'f1vegas',
    component: f1Vegas
  },
  {
    path: '/cesvegas',
    name: 'cesvegas',
    component: cesvegas
  },
  {
    path: '/superbowlvegas',
    name: 'superbowlvegas',
    component: superbowlvegas
  },
  {
    path: '/newzealand',
    name: 'newzealand',
    component: newzealand
  },
  {
    path: '/nodoubtvegas',
    name: 'nodoubtvegas',
    component: nodoubtvegas
  }
]


//ceif auth is false only allow access to /trips
const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

//pre check route and if auth is false only allow access to /trips
router.beforeEach((to, from, next) => {
  //if store auth is false only allow access to /trips
  const auth = store.getters.isAuthenticated;
  
  // Allow access to these routes without authentication
  const publicRoutes = ['james18th', 'home'];
  
  // If route is public, allow access
  if (publicRoutes.includes(to.name)) {
    next()
  } else {
    // For protected routes, require authentication
    // If not authenticated, redirect to home
    // If authenticated, allow access (including /archive and /archive/2025)
    if (!auth) {
      next({ name: 'home' })
    } else {
      next()
    }
  }
})

export default router
